import { render, staticRenderFns } from "./CreateDeliveryFromTemp.vue?vue&type=template&id=49c62ead&lang=pug&"
import script from "./CreateDeliveryFromTemp.vue?vue&type=script&lang=ts&"
export * from "./CreateDeliveryFromTemp.vue?vue&type=script&lang=ts&"
import style0 from "./CreateDeliveryFromTemp.vue?vue&type=style&index=0&id=49c62ead&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports